import * as React from 'react';
import { Controller } from 'react-hook-form';
import Input from '@/components/Input/Input';
import { HookFormProps } from './HookFormProps';
import { forwardRef } from 'react';

export const ControlledInput: React.FC<HookFormProps> = forwardRef(({ onEnter, ...props }: any, ref: any) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={props.rules}
      defaultValue={props.defaultValue ?? ''}
      render={({ field: { onChange, name: fieldName, value }, fieldState: { error } }) => {
        return (
          <Input
            {...props}
            ref={ref}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              onChange(e);
              props.onChange && props.onChange(e);
            }}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                onEnter && onEnter(e);
              }
            }}
            name={fieldName}
            error={error && error.message}
            value={value ?? ''}
          />
        );
      }}
    />
  );
});
